import axios, { AxiosResponse } from "axios";
import { axiosConfig } from "../../config/api/configApi";
import { axiosConfigV2 } from "../../config/api/configApiv2";
import { axiosConfigToUpload } from "../../config/api/configApiUpload";

export const getMyCourseList: (payload: any) => Promise<AxiosResponse<any>> = (
  payload: any
) => {
  return axiosConfig.post(`/v2/api/my-registration/filter-my-courses`, payload);
};

export const uploadFile: (params: any) => Promise<AxiosResponse<any>> = (
  params: any
) => {
  return axiosConfigToUpload.post(
    `/v2/api/mooc-course-block-quiz/upload-file`,
    params
  );
};

export const getTotalMyCourseList: (
  payload: any
) => Promise<AxiosResponse<any>> = (payload: any) => {
  return axiosConfig.post(
    `/v2/api/my-registration/statistic-learning-status`,
    payload
  );
};

export const getUniversityInMyCourse: () => Promise<
  AxiosResponse<any>
> = () => {
  return axiosConfig.get(`/v2/api/my-registration/enterprise`);
};

export const getIndustryInMyCourse: (
  payload: any
) => Promise<AxiosResponse<any>> = (payload: any) => {
  return axiosConfig.post(`/v2/api/my-registration/industry`, payload);
};

export const getEnrollmentHistory: (
  id: number
) => Promise<AxiosResponse<any>> = (id: number) => {
  return axiosConfig.get(`/v2/api/my-registration/history/${id}`);
};

export const getStartLearningCourse: (
  id: number
) => Promise<AxiosResponse<any>> = (id: number) => {
  return axiosConfigV2.get(`/api/my-registration/start-learning-course/${id}`);
};
